import { InfoOutlineIcon } from "@chakra-ui/icons";
import { PlacementWithLogical, IconButton } from "@chakra-ui/react";
import React from "react";
import { TooltipWithTouch } from "../TooltipWithTouch";

export function InfoToolTip({
  label,
  wrap,
  placement = "top",
}: {
  label: string;
  wrap?: boolean;
  placement?: PlacementWithLogical;
}) {
  return (
    <TooltipWithTouch
      label={label}
      aria-label={label}
      hasArrow
      placement={placement}
      fontSize="sm"
      px={3}
      py={2}
      whiteSpace={wrap ? "normal" : "nowrap"}
    >
      <IconButton
        p={0}
        fontSize="1rem"
        icon={<InfoOutlineIcon />}
        variant="ghost"
        aria-label="info tooltip"
        size="xs"
        borderRadius="full"
      />
    </TooltipWithTouch>
  );
}
